<script setup>
import { watch, toRefs, onUnmounted, onMounted } from "vue";
import { useRoute } from "vue-router";
import useCotizacion from "@/composables/useCotizacion";
import CotizacionDatos from "../../components/CotizacionDatos";
import { storeToRefs } from "pinia";
import useStoreCotizaciones from "../../../../store/cotizaciones";

const route = useRoute();
const { params } = toRefs(route);
const {
  fectchInfoCotizacionByToken,
  cotizacionInfo,
  cotizacionTotales,
  consultandoInfoCotizaciones,
} = useCotizacion();

fectchInfoCotizacionByToken(route.params.token);

const {
  arrendamiento,
  arrendamientos,
  btnCargando,
  cliente,
  clientes,
  consultandoInfo,
  descripcion,
  enganche,
  enganches,
  incluyeSeguro,
  importe,
  linea,
  moneda,
  rentas,
  residual,
  residuales,
  seguro,
} = storeToRefs(useStoreCotizaciones());

onMounted(() => {
  cliente.value = "";
  enganche.value = "";
  residual.value = "";
  arrendamiento.value = "";
  importe.value = "";
  rentas.value = "";
  seguro.value = "";
  linea.value = "";
  moneda.value = "";
  descripcion.value = "";
  incluyeSeguro.value = false;
});

watch(
  () => route.params.token,
  (nuevoToken) => {
    fectchInfoCotizacionByToken(nuevoToken);
  },
  { immediate: true }
);
</script>

<template>
  <div
    class="d-flex justify-content-center mt-5"
    v-if="consultandoInfoCotizaciones"
  >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <CotizacionDatos
    :datos="cotizacionInfo"
    :totales="cotizacionTotales"
    :showCopyBtn="true"
    :showRedireccion="true"
    v-else
  />
</template>
